import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer'
import { extrudeSettings } from '../../../../../../utils/Functions'
import WindowModel from './WindowModel'
import HandleOneModel from '../../../ShareModel/HandleModel/HandleOneModel'

const FiveLitePlanWalkInDoor = ({ width, height, trimWidth, doorColor, glassTexture, handlePlacement, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
     

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [height, trimWidth, width])

    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - 0.03) + trimWidth,  (height / 2 - 0.03) - trimWidth);
        model.lineTo(-(width / 2 - 0.03) + trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  (height / 2 - 0.03) - trimWidth);
        model.closePath();

        const holeWindow = new THREE.Path();        
        holeWindow.moveTo(-(width / 2 - trimWidth - width / 6), (height / 2 - height / 4.5));
        holeWindow.bezierCurveTo(
            -(width / 4), (height / 2 - height / 20),
            (width / 4), (height / 2 - height / 20),
            (width / 2 - trimWidth - width / 6), (height / 2 - height / 4.5))
        holeWindow.closePath();

        model.holes.push(holeWindow);

        return model;
    }, [height, trimWidth, width])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='door' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
            
            <WindowModel width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} glassTexture={glassTexture} />
            <HandleOneModel handlePlacement={handlePlacement} width={width}  handleModel={handleModel} />
        </>
    )
}

export default FiveLitePlanWalkInDoor